var map = {
	"./andy-atkinson.png": "0728",
	"./ar-hero.jpg": "5b32",
	"./article-pic.jpg": "7a74",
	"./banner-plastic.png": "6ea2",
	"./bio-david-potts.png": "9e21",
	"./butter.png": "581d",
	"./carousel-banner-01.png": "10c7",
	"./carrier-bags.jpg": "2532",
	"./christmas-carousel-1.jpg": "54d1",
	"./christmas-feature-1.jpg": "4a9a",
	"./christmas-gallery-1.jpg": "da56",
	"./christmas-gallery-2.jpg": "bbfb",
	"./christmas-gallery-3.jpg": "af56",
	"./christmas-gallery-4.jpg": "1fde",
	"./christmas-hero-2023-desktop.jpg": "acfd",
	"./christmas-hero-2023-mobile.jpg": "ecea",
	"./christmas-hero-v2.jpg": "358e",
	"./christmas-hero.jpg": "1541",
	"./christmas-highlight-1.jpg": "ddf4",
	"./christmas-highlight-2.jpg": "6f9f",
	"./corporate-responsibility-banner.png": "f3a2",
	"./cr-fishing-health.jpg": "a935",
	"./cr-fishing-mackerel.png": "d2b1",
	"./cr-fishing-prawns.png": "e34b",
	"./cr-fishing.jpg": "58d9",
	"./cr-hero.jpg": "1e8f",
	"./cr-report-bags.png": "d7ec",
	"./cr-report-fish.png": "c5d1",
	"./cr-wild-capture.jpg": "4664",
	"./cr/bag-group-shot.png": "f5d4",
	"./cr/chicken.png": "e0f2",
	"./cr/clic-sargent.png": "54e1",
	"./cr/colleagues.png": "8d40",
	"./cr/fish.png": "171c",
	"./cr/light-bulb.png": "c42e",
	"./cr/mackerel.png": "f954",
	"./cr/nuts.png": "cb13",
	"./cr/sponge.png": "e74d",
	"./cr/v-taste.png": "ddcd",
	"./cr/wonky-chilli.png": "08c2",
	"./david_potts_x2.jpg": "6286",
	"./farmer.jpg": "df17",
	"./farming-by-numbers--cow.png": "bc6d",
	"./farming-by-numbers--eggs.png": "edcb",
	"./farming-by-numbers--farmer.png": "ee97",
	"./farming-by-numbers--hen.png": "1734",
	"./farming-by-numbers--lamb.png": "958f",
	"./farming-by-numbers--milk.png": "66a8",
	"./farming-by-numbers--pig.png": "96f5",
	"./farming-cow.png": "278e",
	"./farming-homepage.jpg": "3cce",
	"./farming-how-we-work-hero.jpg": "af33",
	"./farming-news-01.png": "8962",
	"./farming-news-02.png": "fbc8",
	"./farming-news-03.png": "87ee",
	"./farming-news-04.png": "7272",
	"./farming-news-05.png": "b245",
	"./farming-news-06.png": "8468",
	"./farming-woodlands-hero.jpg": "cb74",
	"./hilmore-house-02.png": "9462",
	"./hilmore-house.png": "7d03",
	"./history-first-shop.png": "a159",
	"./logos/logo-arla.png": "ff19",
	"./logos/logo-blank.png": "59ec",
	"./logos/logo-issf.png": "4fa3",
	"./logos/logo-responsibly-sourced.png": "08e2",
	"./logos/logo-seafish.png": "5d22",
	"./logos/logo-sfp.png": "450b",
	"./man-fish.jpg": "bbd9",
	"./morrisons-4-3-ratio.jpg": "d6cc",
	"./morrisons_coronavirus_colleague_bonus.jpg": "ea17",
	"./morrisons_nhs_foodbox.webp": "34bf",
	"./quote.png": "4cf1",
	"./seafood-homepage-hero.jpg": "f084",
	"./tabs/ar-tab0.jpg": "186d",
	"./tabs/ar-tab1.jpg": "427e",
	"./tabs/ar-tab2.jpg": "0f00",
	"./tabs/ar-tab3.jpg": "474d",
	"./tabs/ar-tab4.jpg": "9239",
	"./tgtw_x2.webp": "26e9",
	"./video-screen-grab.png": "15f5",
	"./video-title.png": "4bdc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";